<template>
  <div class="settlement-list">
    <el-form inline :model="criteria" size="small">
      <el-form-item label="关键字：">
        <el-input
          v-model.trim="criteria.buyerText"
          @keyup.enter.native="search"
          style="width:350px"
          placeholder="请输入公司抬头/订单编号/提单编号/结算单编号"
        ></el-input>
      </el-form-item>
      <el-form-item label="创建时间：">
        <el-date-picker
          v-model="criteria.dateRang"
          type="daterange"
          align="right"
          unlink-panels
          value-format="yyyy-MM-dd HH:mm:ss"
          range-separator="—"
          :default-time="['00:00:00', '23:59:59']"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        ></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="startSearch">确定</el-button>
        <el-button @click="reset">清除</el-button>
      </el-form-item>
    </el-form>
    <el-tabs :value="activeName" @tab-click="handleTabClick">
      <el-tab-pane label="全部" name="all"></el-tab-pane>
      <el-tab-pane label="待结算确认" name="wait"></el-tab-pane>
      <el-tab-pane label="已结算确认" name="finished"></el-tab-pane>
    </el-tabs>
    <el-table :data="datas" style="width: 100%">
      <el-table-column prop="settleOrderNo" label="结算单号"></el-table-column>
      <el-table-column prop="buyerOrgName" label="采购客户"></el-table-column>
      <el-table-column label="结算单创建时间">
        <template v-slot="scope">
          <span>{{ scope.row.gmtCreated | parseTime }}</span>
        </template>
      </el-table-column>
      <el-table-column label="结算数量/重量">
        <template v-slot="scope">
          {{ `${scope.row.settleQuantity}件/` }}{{ scope.row.settleWeight | formatWeight }}吨
        </template>
      </el-table-column>
      <el-table-column prop="refund" label="结算金额">
        <template v-slot="scope">
          <span>{{ scope.row.settleAmount | currencyFormat }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="结算状态" width="220px">
        <template v-slot="scope">
          <span :style="scope.row.status | convertStatusTag">{{
            scope.row.status | convertStatus
          }}</span>
          <div
            class="f-12 c-hover"
            v-if="
              scope.row.status === 1 &&
                scope.row.remainAutoConfirm &&
                scope.row.remainAutoConfirm > 0
            "
          >
            {{ scope.row.remainAutoConfirm | formatCountDown }}后将自动确认结算
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="opreate" label="操作">
        <template v-slot="scope">
          <el-button type="text" @click="goDetail(scope)">查看详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      style="margin:20px;text-align:right;"
      v-show="total > 0"
      @size-change="handleSizeChange"
      @current-change="paging"
      :current-page="criteria.pageNo"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="criteria.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    ></el-pagination>
  </div>
</template>

<script>
const defaultCriteria = {
  buyerText: '',
  dateRang: [],
  pageNo: 1,
  pageSize: 10
}

const TIME = {
  day: 24 * 60 * 60 * 1000,
  hour: 60 * 60 * 1000,
  minute: 60 * 1000,
  second: 1000
}

export default {
  name: 'SettlementList',
  data() {
    return {
      total: 0,
      datas: [],
      criteria: { ...defaultCriteria },
      activeName: 'all',
      timerId: null,
      refTime: null,
      refCount: 0
    }
  },
  filters: {
    formatCountDown(timestamp) {
      if (!timestamp || timestamp === 0) return ''
      const day = parseInt(timestamp / TIME.day)
      const hour = parseInt((timestamp - day * TIME.day) / TIME.hour)
      const minute = parseInt((timestamp - day * TIME.day - hour * TIME.hour) / TIME.minute)
      const second = parseInt(
        (timestamp - day * TIME.day - hour * TIME.hour - minute * TIME.minute) / TIME.second
      )

      return `${day}天${hour}时${minute}分${second}秒`
    },
    convertStatus(status) {
      let text = ''
      if (status === 1) {
        text = '待结算确认'
      } else if (status === 2 || status === 3) {
        text = '已结算确认'
      }
      return text
    },
    convertStatusTag(status) {
      let text = 'color:#909399;'
      if (status === 1) {
        text = 'color:#e6a23c;'
      } else if (status === 2 || status === 3) {
        text = 'color:#67c23a;'
      }
      return text
    }
  },
  created() {
    this.startSearch()
  },
  activated() {
    this.startSearch()
  },
  beforeDestroy() {
    this.stopCountDown()
  },
  deactivated() {
    this.stopCountDown()
  },
  methods: {
    handleTabClick(tab) {
      if (tab.name === this.activeName) return
      this.activeName = tab.name
      this.criteria.pageNo = 1
      this.startSearch()
    },
    goDetail(scope) {
      this.$router.push({
        name: 'SettlementDetail',
        params: { id: scope.row.settleOrderId }
      })
    },
    reset() {
      this.criteria = { ...defaultCriteria }
      this.startSearch()
    },
    paging(page) {
      this.criteria.pageNo = page
      this.startSearch()
    },
    handleSizeChange(val) {
      this.criteria.pageSize = val
      this.startSearch()
    },
    async startSearch() {
      const request = {}
      Object.keys(this.criteria).forEach(key => {
        if (!this.criteria[key]) {
          return
        }
        if (key === 'dateRang') {
          if (this.criteria[key].length === 2) {
            request.settleOrderCreatedBegin = this.criteria[key][0]
            request.settleOrderCreatedEnd = this.criteria[key][1]
          }
        } else {
          request[key] = this.criteria[key]
        }
      })

      if (this.activeName === 'wait') {
        request.status = 1
      } else if (this.activeName === 'finished') {
        request.status = 2
      }
      try {
        const { success, data } = await this.$post('settle.seller.querySettleOrders', { request })
        if (success && data) {
          const { totalNum, settleOrderVOList } = data[0]
          this.total = totalNum
          this.datas = settleOrderVOList
        } else {
          this.total = 0
          this.datas = []
        }
        if (this.activeName === 'finished') {
          this.stopCountDown()
        } else {
          this.startCountDown()
        }
      } catch (e) {
        console.log(e)
        this.total = 0
        this.datas = []
        this.stopCountDown()
      }
    },
    handleCountDown() {
      this.refCount += 1
      const offset = new Date().getTime() - (this.refTime + this.refCount * 1000)
      const nextTime = 1000 - offset

      let needCountDown = false
      for (let i = 0; i < this.datas.length; i++) {
        const ele = this.datas[i]
        if (ele.remainAutoConfirm && ele.remainAutoConfirm > 0) {
          needCountDown = true
          ele.remainAutoConfirm = ele.remainAutoConfirm - 1000
          if (ele.remainAutoConfirm <= 0) {
            needCountDown = false
            this.startSearch()
            break
          }
        }
      }
      if (needCountDown) {
        this.timerId = setTimeout(this.handleCountDown, nextTime)
      }
    },
    startCountDown() {
      this.stopCountDown()
      this.refTime = new Date().getTime()
      this.refCount = 0
      this.timerId = setTimeout(this.handleCountDown, 1000)
    },
    stopCountDown() {
      this.timerId && clearTimeout(this.timerId)
    }
  }
}
</script>
